import {
  Box,
  chakra,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Heading,
  HStack,
  IconButton,
  Stack,
  useDisclosure,
} from "@chakra-ui/react";
import { NavLink as RouterNavLink, useNavigate } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import { AiOutlineClose, AiOutlineWhatsApp } from "react-icons/ai";
import { useRef } from "react";

const ChakraRouterLink = chakra(RouterNavLink as any);

const whatsappMessage =
  "https://wa.me/+51993652788/?text=Estimada+psic%c3%b3loga%2c+tengo+la+siguiente+consulta";

interface NavLinkProps {
  name: string;
  path: string;
  onClose: () => void;
}

const WhatsAppLink = (props: NavLinkProps) => (
  <chakra.a
    px={4}
    py="0.45rem"
    marginLeft={2}
    display="inline-flex"
    alignItems="center"
    gap="0.3rem"
    rounded="full"
    fontWeight="600"
    fontSize="sm"
    bg="sage.400"
    color="white"
    _hover={{ textDecoration: "none", bg: "sage.600" }}
    onClick={() => props.onClose()}
    target="_blank"
    href={props.path}
  >
    <AiOutlineWhatsApp size={18} />
    <Box as="span">{props.name}</Box>
  </chakra.a>
);

const NavLink = (props: NavLinkProps) => (
  <ChakraRouterLink
    px={3}
    py={2}
    rounded="md"
    fontSize="sm"
    fontWeight="500"
    color="gray.700"
    _hover={{ textDecoration: "none", bg: "sage.50", color: "sage.700" }}
    sx={{ "&.active": { bg: "sage.100", color: "sage.700", fontWeight: "600" } }}
    onClick={() => props.onClose()}
    to={props.path}
  >
    {props.name}
  </ChakraRouterLink>
);

const TopNav = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef: any = useRef();
  const navigate = useNavigate();

  return (
    <Box
      bg="white"
      px={4}
      boxShadow="sm"
      borderBottomWidth="1px"
      borderBottomColor="sage.100"
      position="sticky"
      top="0"
      zIndex="10"
    >
      <Flex
        alignItems="center"
        justifyContent="space-between"
        w={["100%", "95%", "90%"]}
        maxW={960}
        mx="auto"
        py={4}
      >
        <Heading
          as="h1"
          fontSize={["0.95rem", "1.1rem", "1.25rem"]}
          fontFamily="heading"
          fontWeight="600"
          color="sage.600"
          letterSpacing="tight"
          whiteSpace="nowrap"
          cursor="pointer"
          onClick={() => navigate("/")}
          _hover={{ color: "sage.700" }}
        >
          Psicóloga Beatriz Sifuentes
        </Heading>

        <HStack spacing={1} display={{ base: "none", md: "flex" }}>
          <NavLink name="Inicio" path="/" onClose={onClose} />
          <NavLink name="Servicios" path="/services" onClose={onClose} />
          <WhatsAppLink name="Contáctame" path={whatsappMessage} onClose={onClose} />
        </HStack>

        <IconButton
          ref={btnRef}
          size="md"
          icon={isOpen ? <AiOutlineClose /> : <GiHamburgerMenu />}
          aria-label="Abrir menú"
          bg="sage.50"
          color="sage.700"
          _hover={{ bg: "sage.100" }}
          _active={{ bg: "sage.200" }}
          display={{ base: "flex", md: "none" }}
          onClick={isOpen ? onClose : onOpen}
        />
      </Flex>

      <Drawer isOpen={isOpen} placement="left" onClose={onClose} finalFocusRef={btnRef}>
        <DrawerOverlay />
        <DrawerContent bg="white">
          <DrawerCloseButton color="sage.600" />
          <DrawerHeader
            fontFamily="heading"
            color="sage.700"
            borderBottomWidth="1px"
            borderBottomColor="sage.100"
          >
            Psicóloga Beatriz Sifuentes
          </DrawerHeader>
          <DrawerBody pt={4}>
            <Stack as="nav" spacing={2}>
              <NavLink name="Inicio" path="/" onClose={onClose} />
              <NavLink name="Servicios" path="/services" onClose={onClose} />
              <WhatsAppLink name="Contáctame" path={whatsappMessage} onClose={onClose} />
            </Stack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>
  );
};

export default TopNav;
